<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{alterar}} Promoção</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field
                box
                ref="cod_produto"
                mask="#######"
                autofocus
                v-model="promocao.cod_produto"
                label="Código Produto"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                box
                label="% Desconto"
                ref="desconto"
                v-model="promocao.desconto"
                hint="Utilize ponto e números ex:0.00 "
                required
              ></v-text-field>
            </v-flex>
            <v-flex s12 sm6>
              <v-select
                v-model="promocao.dia_semana"
                :items="diasSemana"
                item-text="dia"
                item-value="dia_semana"
                label="Dia da Semana"
                single-line
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="170"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  outline
                  slot="activator"
                  v-model="dataFimFormatted"
                  label="Validade"
                  readonly
                  persistent-hint
                  prepend-icon="event"
                  @blur="promocao.validade = parseDate(dataFimFormatted)"
                  required
                ></v-text-field>
                <v-date-picker locale="pt-br" v-model="dataFim" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*Campos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="white--text" color="terciary" @click.native="parente()">Cancelar</v-btn>
        <v-btn
          class="white--text"
          color="sucesso"
          @click.native="promocao.id==''? salvar():atualizar()"
        >Gravar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
import { VMoney } from "v-money";

var moment = require("moment");

export default {
  name: "FormCadpromocao",
  props: ["dialog", "dados", "zeraCampos"],
  mixins: [formata],
  directives: { money: VMoney },
  data: () => ({
    diasSemana: [
      { dia_semana: 0, dia: "Todos" },
      { dia_semana: 1, dia: "Domingo" },
      { dia_semana: 2, dia: "Segunda-Feira" },
      { dia_semana: 3, dia: "Terça-Feira" },
      { dia_semana: 4, dia: "Quarta-Feira" },
      { dia_semana: 5, dia: "Quinta-Feira" },
      { dia_semana: 6, dia: "Sexta-Feira" },
      { dia_semana: 7, dia: "Sábado" }
    ],
    money: {
      decimal: ".",
      thousands: " ",
      prefix: "",
      suffix: "",
      precision: 2,
      masked: true /* doesn't work with directive */
    },
    promocao: {
      cod_produto: "",
      desconto: "",
      validade: "",
      dia_semana: "",
      id: ""
    },
    menu: "",
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),
    alterar: "",
    cnpjRules: [
      v => !!v || "Cnpj é requerido",
      v => v.length == 14 || "Cnpj   Menor que o padrão"
    ]
  }),
  mounted() {
    //  alert("ativou");
    //this.$refs.cod_produto.focus();
    //this.$refs.cod_produto.select();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    zeraCampos(val) {
      if (val == "novo") {
        this.promocao.cod_produto = "";
        this.promocao.desconto = "";
        this.promocao.dia_semana = "";
        (this.dataFim = moment().format("YYYY-MM-DD")),
          (this.dataFimFormatted = moment().format("DD/MM/YYYY"));
      }
      // alert("alterou");

      // this.dataFim = this.parseDate(val.validade);
    },
    dados(val) {
      if (val) {
        this.promocao.cod_produto = val.cod_produto;

        this.promocao.validade = val.validade;
        this.dataFim = this.parseDate(val.validade);
        this.promocao.id = val.id;
        this.promocao.dia_semana = val.dia_semana;
        this.alterar = "Alterar ";
        setTimeout(() => {
          // alert(val.desconto);
          this.promocao.desconto = val.desconto;
        }, 1000);
      } else {
        this.promocao.id = "";
        this.alterar = "";
      }
    },
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
      this.promocao.validade = this.parseDate(this.dataFimFormatted);
    }
  },

  methods: {
    atualizar() {
      HTTP.put(`promocao/` + this.promocao.id, this.promocao)
        .then(response => {
          this.promocao.id = "";

          this.$emit("gravacaoOkpromocao");
          this.$emit("fechaDialog");
          this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");

          this.zeraCampos("novo");
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          if (e.response != undefined) {
            if (!Array.isArray(e.response.data.error)) {
              let itens = [];
              for (var prop in e.response.data.error) {
                itens.push(e.response.data.error[prop][0]);
              }

              this.$emit("getCadpromocao", itens.join(","));
            }
          }
        });
      // this.$parent.selDialog = false;
    },
    salvar() {
      HTTP.post(`promocao`, this.promocao)
        .then(response => {
          if (response.data.error) {
            alert("erross:");
          }
          this.promocao.cod_produto = "";
          this.promocao.desconto = "";
          this.promocao.validade = "";
          this.$emit("gravacaoOkpromocao");
          this.$emit("fechaDialog");
          this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
        })
        .catch(e => {
          // console.log("erros:::::" + e.response.data.errors);
          console.log(e.response.data.error);
          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }

            this.$emit("getCadpromocao", itens.join(","));
          }
        });
      // this.$parent.selDialog = false;
    },
    parente() {
      this.$emit("fechaDialog");
    },

    checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscapromocaos() {
      this.loading = true;
      HTTP.get(`grupo/lista/promocao`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =

          this.items = response.data;
          this.mostraCartoes = true;
        }
        this.loading = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/FormCadPromocao.vue